import * as React from 'react';

import { EActionType } from '../../../../../../../shared/repositories/search-offers.legacy/v2/types/dailyrentData';
import { useIsDailyrentOnlineBookingEnabled } from '../../../../../../../shared/utils/featureToggles/useIsDailyrentOnlineBookingEnabled';
import { DailyrentActionsLayout } from '../../../../components/DailyrentActionsLayout';
import { useOfferContext } from '../../../../context';
import { AgentPhoneButtonContainer } from '../AgentPhoneButtonContainer';
import { AgentShowMoreOffersContainer } from '../AgentShowMoreOffersContainer';
import { OfferChatButtonContainer } from '../OfferChatButtonContainer';
import { isCianPartner as isCianPartnerUtil } from 'shared/utils/dailyrent/isCianPartner';

export const DailyrentActionButtonsContainer = () => {
  const offerData = useOfferContext();
  const {
    offer: { dailyrent },
  } = offerData;
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionType = dailyrent?.actionType || EActionType.Contact;

  const isOnlineBookingActionType = [EActionType.OtaBooking, EActionType.OtaCheckDates].includes(actionType);
  const showOnlyChatButton = actionType === EActionType.Chat;
  const showOnlineBookingButtons = isDailyrentOnlineBookingEnabled && isOnlineBookingActionType;

  const isCianPartner = isCianPartnerUtil(offerData.offer);

  if (showOnlyChatButton || isCianPartner) {
    return null;
  }

  if (showOnlineBookingButtons) {
    return (
      <DailyrentActionsLayout>
        <AgentShowMoreOffersContainer />
      </DailyrentActionsLayout>
    );
  }

  return (
    <DailyrentActionsLayout>
      <AgentShowMoreOffersContainer />
      <AgentPhoneButtonContainer />
      <OfferChatButtonContainer />
    </DailyrentActionsLayout>
  );
};
